import { useModal } from '../../../../providers/ModalProvider/ModalProvider'

import {
  formatEventStart,
  getSinglarOrPluralWord,
  timezones,
} from '../../../../utilities/helpers'

import Modal from 'react-bootstrap/Modal'
import Form from 'react-bootstrap/Form'
import Image from 'react-bootstrap/Image'
import Stack from 'react-bootstrap/Stack'

import { Error } from '../../../Error'
import { Spinner } from '../../../LoadingContainer/Spinner'

import placeholder from '../../../../assets/placeholder.png'

export default function SelectEvents({
  orgEvents,
  error,
  isLoadingEvents,
  selected,
  setSelected,
}) {
  const { closeModal, openModal } = useModal()

  const handleCheck = (e) => {
    const { value } = e.target
    if (selected.includes(Number(value))) {
      setSelected((prevState) => prevState.filter((id) => id !== Number(value)))
    } else {
      setSelected((prevState) => [...prevState, Number(value)])
    }
  }

  const handleSelectAll = () => {
    if (selected.length === orgEvents?.length) {
      setSelected([]) // Deselect all
    } else {
      setSelected(orgEvents?.map((event) => Number(event?.id))) // Select all
    }
  }

  const checker = (arr) => {
    return arr.every((evt) => selected.includes(evt.id))
  }

  if (isLoadingEvents) {
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ minHeight: '200px' }}
      >
        <div className="text-center">
          <Spinner variant="dark" size="lg">
            <span className="visually-hidden">Loading...</span>
          </Spinner>
          <div className="mt-3">Loading events...</div>
        </div>
      </div>
    )
  }

  if (error) {
    return (
      <div style={{ paddingTop: 32 }}>
        <Error
          title="Error loading events!"
          description={null}
          onClose={closeModal}
        />
      </div>
    )
  }

  return (
    <>
      <div className="header pt-0 mb-2">
        <Form.Check
          label="Select all"
          type="checkbox"
          checked={checker(orgEvents)}
          id="all"
          className="mb-0"
          onChange={handleSelectAll}
        />
      </div>
      <Modal.Body className="pb-0">
        <Stack gap={2} as="ul">
          {orgEvents?.map((event, idx) => (
            <li
              key={idx}
              className={`list-item list-item-lg list-item--hover-primary ${selected.includes(event.id) ? 'selected' : ''}`}
            >
              <Form.Check
                type="checkbox"
                className="form-check-display m-0"
                id={`event-display-checkbox-${event.id}`}
              >
                <Form.Check.Input
                  type="checkbox"
                  name="event"
                  value={event.id}
                  className="flex-shrink-0"
                  checked={selected.includes(Number(event.id))}
                  onChange={handleCheck}
                />
                <Stack direction="horizontal" gap={3} className="flex-grow-1">
                  <Form.Check.Label
                    id={`event-display-checkbox-${event.id}`}
                    className="m-0 d-flex gap-3 w-100 h-100 align-items-center"
                  >
                    <Image
                      src={event.image.url || placeholder}
                      alt={`Cover art for ${event.name} event`}
                      width="64"
                      height="64"
                      className="event-image card-img-xs"
                    />
                    <Stack gap={1} className="justify-content-center">
                      <h5 className="normal m-0">{event?.name}</h5>
                      <p className="text-muted small small-bold">
                        <span>
                          {formatEventStart(
                            event,
                            timezones(event?.venue?.timezone)
                          )}
                        </span>
                      </p>
                    </Stack>
                  </Form.Check.Label>
                </Stack>
              </Form.Check>
            </li>
          ))}
        </Stack>
      </Modal.Body>
      <div className="p-4 pb-0">
        <small>
          {selected?.length} {getSinglarOrPluralWord(selected?.length, 'event')}{' '}
          selected
        </small>
      </div>
    </>
  )
}
